import {
  BookOpenIcon,
  InboxInIcon,
  PhoneIcon,
  PhoneOutgoingIcon,
} from '@heroicons/react/outline';
import { InboxIcon, LocationMarkerIcon } from '@heroicons/react/solid';
import Nav from '../components/Nav';

const Contact = () => {
  return (
    <div className="bg-gray-50 w-full h-full">
      <Nav />
      <div className="container mx-auto  bg-gray-50 text-gray-700 pb-20">
        <section className="relative block h-[700px]">
          <img
            src="banner.png"
            className="absolute top-0 w-full h-full bg-center bg-cover"
            alt=""
          />

          <span
            id="blackOverlay"
            className="w-full h-full absolute opacity-20 bg-black"
          ></span>
        </section>

        <section className="bg-gray-100">
          <div className="container mx-auto px-4 ">
            <div className="relative flex flex-col min-w-0 break-words bg-gray-50 w-full mb-6 shadow-xl rounded-lg -mt-64">
              <div className="container mx-auto">
                <div className="py-10 container mx-auto mb-20 sm:mx-auto text-justify bg-gray-100 rounded-md p-8">
                  <div className="bg-gray-50 z-50 opacity-95 h-80 container max-w-7xl rounded justify-center items-center flex flex-col text-yellow-700">
                    <button className="text-3xl animate-bounce antialiased font-bold tracking-widest rounded-md uppercase bg-gradient-to-r from-yellow-600 text-white to-yellow-900 py-2 px-8 opacity-100 transition-all  duration-100 hover:scale-105 transform">
                      <PhoneOutgoingIcon className="h-6 w-6 inline-flex " />{' '}
                      Give Us A call
                    </button>
                    <blockquote className="mt-5 px-2 flex flex-col lg:flex-row justify-between space-y-20 lg:space-y-0 lg:space-x-20 text-center uppercase">
                      <div className="text-sm text-center text-gray-700 mb-5">
                        <p className="font-bold text-yellow-700  text-lg ">
                          {' '}
                          <PhoneIcon className="h-4 w-4 inline-flex text-yellow-700" />{' '}
                          Call
                        </p>
                        0218838283 0234829832 283823923892
                        <p className="font-bold text-yellow-700  text-lg ">
                          {' '}
                          <InboxIcon className="h-4 w-4 inline-flex text-yellow-700" />{' '}
                          Whatsapp
                        </p>
                        0218838283 0234829832 283823923892
                      </div>
                      <div className="text-sm text-center text-gray-700 mb-5">
                        <p className="font-bold text-yellow-700  text-lg ">
                          {' '}
                          <InboxInIcon className="h-4 w-4 inline-flex text-yellow-700" />{' '}
                          Send Email
                        </p>
                        0218838283 0234829832 283823923892
                        <p className="font-bold text-yellow-700  text-lg ">
                          {' '}
                          <InboxIcon className="h-4 w-4 inline-flex text-yellow-700" />{' '}
                          Outlook
                        </p>
                        0218838283 0234829832 283823923892
                      </div>
                      <div className="text-sm text-center text-gray-700 mb-5">
                        <p className="font-bold text-yellow-700  text-lg ">
                          {' '}
                          <LocationMarkerIcon className="h-4 w-4 inline-flex text-yellow-700" />{' '}
                          Location
                        </p>
                        0218838283 0234829832 283823923892
                        <p className="font-bold text-yellow-700  text-lg ">
                          {' '}
                          <InboxIcon className="h-4 w-4 inline-flex text-yellow-700" />{' '}
                          Address
                        </p>
                        0218838283 0234829832 283823923892
                      </div>
                    </blockquote>
                  </div>
                  <div className="max-w-3xl mx-auto bg-gray-100 shadow-lg p-10 rounded-lg">
                    <form className="flex flex-col space-y-2 py-4 ">
                      <div className="flex flex-col justify-center items-center">
                        <BookOpenIcon className=" text-yellow-700 h-16 w-16" />
                        <h1 className="text-4xl font-bold text-yellow-700 text-center">
                          Contact us Form
                        </h1>
                      </div>
                      <input
                        type="text"
                        required
                        placeholder="Fullname eg John Doe"
                        className="px-10 py-2 outline-none focus:ring-1 ring-yellow-700 rounded-md placeholder-yellow-700"
                      />
                      <input
                        required
                        type="email"
                        placeholder="Email eg John@doe.com"
                        className="px-10 py-2 outline-none focus:ring-1 ring-yellow-700 rounded-md placeholder-yellow-700"
                      />
                      <input
                        required
                        type="number"
                        placeholder="Number (+233-540-000-000)"
                        className="px-10 py-2 outline-none focus:ring-1 ring-yellow-700 rounded-md placeholder-yellow-700"
                      />

                      <textarea
                        required
                        cols="3"
                        type="text"
                        placeholder="Your Message"
                        className="px-10  outline-none focus:ring-1 ring-yellow-700 rounded-md placeholder-yellow-700"
                      />
                      <button className="mt-2 px-8 py-2 text-lg text-white bg-yellow-700 rounded-lg hover:bg-yellow-700 active:bg-yellow-300 focus:ring-1 ring-yellow-900">
                        Submit
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Contact;
